import { Button } from "@models/configurators/button";
import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPopup } from "@models/entity-models";

@Kbo(CToken.Popup)
export class Popup extends Button implements IPopup {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public popupWidth: string;
    public popupHeight: string;
    
    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return this.containerChildren(rootType);
    }
}
